module.exports = __webpack_public_path__ + "static/banner--1-d73ddf866fa7254736de51b42e98e803.jpg";